import i18n from '@/i18n'

export default function i18nScopedMsgs(scope, func = i18n.global.t) {
  return (key, ...args) => {
    return func(`${scope}.${key}`, ...args)
  }
}
